<template>
  <div v-if="showLoading">
    <div class="indicator-wrapper" :style="{ 'padding': showLoading.text ? '20px' : '15px' }">
      <div class="spinner-snake"></div>
      <div class="indicator-text" v-show="showLoading.text">{{ showLoading.text }}</div>
    </div>
    <div class="indicator-mask" @touchmove.stop.prevent></div>
  </div>
</template>

<script>
// https://github.com/ElemeFE/ui/blob/master/packages/indicator/src/indicator.vue
export default {
  name: 'loading',
  data() {
    return {};
  },
  props: ['showLoading'],
};
</script>

<style scoped>
.indicator-wrapper {
  top: 50%;
  left: 50%;
  position: fixed;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.indicator-text {
  display: block;
  color: #fff;
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
}
.indicator-mask {
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: transparent;
}

.spinner-snake {
  animation: spinner-rotate 0.8s infinite linear;
  border: 4px solid transparent;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  border-top-color: rgb(204, 204, 204);
  border-left-color: rgb(204, 204, 204);
  border-bottom-color: rgb(204, 204, 204);
}

@keyframes spinner-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue